// extracted by mini-css-extract-plugin
export default {"ItemDeletedToast__Image":"ItemDeletedToast-styles__ItemDeletedToast__Image__h87NM"};